import {
  STATUS_ACCEPT,
  STATUS_CONCEPT,
  STATUS_ARCHIVE,
  STATUS_DRAFT,
  STATUS_TRASH,
  STATUS_SEND,
  STATUS_PROCCESS
} from '../const/surat';

export default (surat) => {
  function isUserHasAction(userId) {
    if (!surat) return false;
    return (
      isUserCanDisposition(userId) ||
      isUserCanArchive ||
      isUserCanUnarchive
    );
  }

  function isUserCanDisposition(userId) {
    if (!surat) return false;
    const dispositionableStatus = [STATUS_DRAFT, STATUS_ACCEPT, STATUS_CONCEPT];
    const isDispositionStatus = dispositionableStatus.includes(surat.status);
    return isUserOnDisposition(userId) && isDispositionStatus;
  }

  function isUserCanSend(userId) {
    if (!surat) return false;
    const canSendStatus = [STATUS_ACCEPT];
    const canSend = canSendStatus.includes(surat.status);
    return isUserOnDisposition(userId) && canSend && surat.tipe == 'surat_keluar';
  }

  function isDisabledSendMail() {
    if (!surat) return true;
    return surat.surat_keluar.pengirim_id == null;
  }

  function isUserCanArchive(userId) {
    if (!surat) return false;
    const cannotArchiveStatus = [STATUS_ARCHIVE, STATUS_TRASH, STATUS_SEND];
    const canArchive = !cannotArchiveStatus.includes(surat.status);
    return isUserOnDisposition(userId) && canArchive && surat.tipe == 'surat_masuk';
  }

  function isUserCanUnarchive(userId) {
    if (!surat) return false;
    const canArchiveStatus = [STATUS_ARCHIVE];
    const canArchive = canArchiveStatus.includes(surat.status);
    return isUserOnDisposition(userId) && canArchive;
  }

  function isUserCanEdit(userId) {
    if (!surat) return false;
    const cannotEditStatus = [STATUS_ARCHIVE, STATUS_ACCEPT,STATUS_SEND]
    const cannotEdit = !cannotEditStatus.includes(surat.status)
    return isUserOwn(userId) && cannotEdit;
  }

  function isUserCanSign({
    userId,
    documentAttribute
  }) {
    if (!surat) return false;
    const remainUsers = this.parseDocumentAttributesGetRemainingUsersToSign(documentAttribute)
    const canSign = isUserHasSigned({
      userId: userId,
      whitelists: remainUsers
    })
    return canSign
  }

  function isUserHasSigned({
    userId,
    whitelists
  }) {
    return whitelists.indexOf(userId) != -1;
  }

  function parseDocumentAttributes(attribute) {
    if (attribute) {
      const attr = JSON.parse(attribute);
      let signs = [];
      if (attr)
        if (attr.signs)
          signs = attr.signs;
      return signs
    } else {
      return null
    }

  }

  function parseDocumentAttributesGetRemainingUsersToSign(attribute) {
    var remain = [];
    if (attribute) {
      attribute = JSON.parse(attribute);
      if (attribute && attribute.remainingUsersToSign) {
        remain = attribute.remainingUsersToSign;
      }
    }
    return remain;
  }

  function isUserCanGetNumber() {
    if (!surat) return false;
    const cannotGetNumberStatus = [STATUS_ARCHIVE, STATUS_ACCEPT, STATUS_TRASH]
    const cannotGetNumber = !cannotGetNumberStatus.includes(surat.status)
    return cannotGetNumber && surat.tipe === 'surat_keluar' && !surat.nomor_surat;
  }

  function isUserOwn(userId) {
    if (!surat) return false;
    return String(surat.pengguna.id) === String(userId);
  }

  function isUserOnDisposition(userId) {
    if (!surat) return false;
    const lastDispositionUserId = surat.disposisi_terakhir_pengguna_id ?
      surat.disposisi_terakhir_pengguna_id :
      getLastTargetDispositionUserId();
    return String(lastDispositionUserId) === String(userId);
  }

  function getLastTargetDispositionUserId() {
    const lastDisposition = getLastDisposition();
    if (!lastDisposition || !lastDisposition.tujuan_pengguna)
      return surat.pengguna.id;
    return lastDisposition.tujuan_pengguna.id;
  }

  function getLastDisposition() {
    if (!surat || !surat.disposisi.length) return null;
    return surat.disposisi.reduce((previous, current) =>
      previous.id > current.id ? previous : current
    );
  }

  function getDocumentIds() {
    if (!surat || !surat.dokumen.length) return [];
    return surat.dokumen.map((item) => item.id);
  }

  function isInbox() {
    return surat.tipe === 'surat_masuk';
  }

  function isUserCanTrash(userId) {
    if (!surat) return false;
    const cannotTrashStatus = [STATUS_ARCHIVE, STATUS_ACCEPT, STATUS_PROCCESS, STATUS_SEND, STATUS_TRASH]
    const cannotTrash = !cannotTrashStatus.includes(surat.status)
    return isUserOwn(userId) && cannotTrash;
  }

  function isUserCanUntrash(userId) {
    if (!surat) return false;
    const canUntrashStatus = [STATUS_TRASH]
    const canUntrash = canUntrashStatus.includes(surat.status)
    return isUserOwn(userId) && canUntrash;
  }

  function isUserCanAgenda() {
    if (!surat) return false;
    const cannotAgendaStatus = [STATUS_TRASH]
    const cannotAgenda = !cannotAgendaStatus.includes(surat.status)
    return cannotAgenda;
  }

  return {
    ...surat,
    lastTargetDispositionUserId: getLastTargetDispositionUserId(),
    lastDisposition: getLastDisposition(),
    isInbox: isInbox(),
    documentIds: getDocumentIds(),
    parseDocumentAttributes,
    isUserHasAction,
    isUserCanDisposition,
    isUserCanArchive,
    isUserCanSend,
    isUserCanUnarchive,
    isUserCanEdit,
    isUserCanSign,
    isUserCanGetNumber,
    isUserOwn,
    isUserOnDisposition,
    parseDocumentAttributesGetRemainingUsersToSign,
    isUserCanTrash,
    isUserCanAgenda,
    isUserCanUntrash,
    isDisabledSendMail
  };
};
